<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "RecipientMails",
  model: {
    prop: "modelValue",
    event: "on-change-model-value",
  },
  emit: ["on-change-input"],
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const handleRecipientMails = (type, index) => {
      if (type === "add") {
        const mailObj = { name: "", email: "" };
        props.modelValue.push(mailObj);
      } else {
        props.modelValue.splice(index, 1);
      }
    };

    // 输入内容切换事件
    const handelChangeInput = () => {
      emit("on-change-input");
    };

    return {
      handleRecipientMails,
      handelChangeInput,
    };
  },
});
</script>

<template>
  <div class="recipient-mails">
    <div v-for="(item, index) in modelValue" :key="index" class="input-item">
      <a-input v-model="item.name" placeholder="请输入收件人名称" @change="handelChangeInput" />
      <a-input v-model="item.email" placeholder="请输入收件人邮箱" @change="handelChangeInput" />
      <a-icon type="plus-circle" @click="handleRecipientMails('add')" />
      <a-icon v-if="index" type="minus-circle" @click="handleRecipientMails('remove', index)" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.recipient-mails {
  .input-item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }

    /deep/.ant-input {
      width: 257px;
      margin-right: 10px;
    }

    i {
      cursor: pointer;
      color: #7e8694;
    }

    i:nth-of-type(1) {
      margin-right: 16px;
    }
  }
}
</style>
